import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const includes = ['5 printable STEM volumes', '120 hands-on build cards', 'Easy → Guided → Challenge progression', 'Materials, time, safety, and help level shown upfront', '5 maker bonuses included', 'Instant digital access', 'One-time payment of $27 USD'];
export function ClosingBlock() {
  return <section id="closing" className="w-full scroll-mt-20 bg-navy px-5 py-14 sm:py-24" data-id="element-52" data-mp="20rt3t6r4tpna">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-53" data-mp="1w0b56pcl015h">
        <h2 className="font-serif-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-54" data-mp="1mybm7ri0amzw">
          More making. Less “I’m bored.”
        </h2>
        <p className="mt-4 text-base font-semibold text-yellow sm:text-lg" data-id="element-55" data-mp="1d39xuxvk1oyd">
          The Young Inventor Lab™ gives curious kids a clear path from idea to finished creation.
        </p>

        <ul className="mt-8 grid w-full max-w-md gap-3 text-left" data-id="element-56" data-mp="3sl7te61gicst">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-57" data-mp="3dwbb7g5orjeh">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal/20 text-teal" data-id="element-58" data-mp="3iu3e157vcpxg">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-59" data-mp="ae9usim5l0cp" />
              </span>
              <span className="text-sm leading-relaxed text-white/85" data-id="element-60" data-mp="fdwbj216wyq9">{item}</span>
            </li>)}
        </ul>

        <span className="mt-10 font-serif-display text-[52px] font-bold leading-none text-white sm:text-7xl" data-id="element-61" data-mp="fkeuvdthpz3">
          $27 USD
        </span>

        <motion.a href="#get-access" animate={{
        y: [0, -2, 0],
        scale: [1, 1.015, 1]
      }} whileHover={{
        scale: 1.025,
        boxShadow: '0 16px 34px -10px rgba(255, 107, 53, 0.7)'
      }} whileTap={{
        scale: 0.98
      }} transition={{
        y: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        scale: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        type: 'spring',
        stiffness: 400,
        damping: 22
      }} className="mt-9 flex min-h-[58px] w-full max-w-md items-center justify-center rounded-[14px] bg-spark px-6 py-4 text-base font-extrabold tracking-tight text-white shadow-lg shadow-spark/40 sm:text-lg" data-id="element-62" data-mp="2l6kvj2oeo9g9">
          GET THE FULL INVENTOR LAB
        </motion.a>
        <p className="mt-3 text-xs text-white/60" data-id="element-63" data-mp="8zgyvk3w7k8o">
          Instant digital download · One-time payment
        </p>
      </motion.div>
    </section>;
}